const logger = {
    log(msg, ...rest) {
        if (RedBull.config.debugLoggingEnabled) {
            console.log(msg, ...rest);
        }
    },
    debug(msg, ...rest) {
        if (RedBull.config.debugLoggingEnabled) {
            console.debug(msg, ...rest);
        }
    },
    error(msg, ...rest) {
        console.error(msg, ...rest);
    },
    info(msg, ...rest) {
        console.info(msg, ...rest);
    }
};

export default logger;
